module.exports = __webpack_public_path__ + "img/source_serif+source_sans.24990e8c.png";